import { GeolocationOptions } from './Model/geolocation-options';
import { GeolocationPosition } from './Model/geolocation-position';

/**
 * Abstract service for handling geolocation functionality
 */
export abstract class GeolocationService {
    /**
     * Get the current position of the device
     *
     * @param options Optional configuration for the geolocation request
     *
     * @returns A promise that resolves with the current position
     *
     * @throws GeolocationError with human-readable message
     */
    abstract getCurrentPosition(options?: GeolocationOptions): Promise<GeolocationPosition>;
}
